// Delegated event handler for dynamically injected quick view PDP button
// This must be loaded globally (in theme.liquid or main JS bundle)
(function() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.js-visit-pdp-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    // Find the correct variant select
    const root = btn.closest('.js-quick-view');
    const select = root && root.querySelector('.js-quick-view-hidden-select');
    const url = select ? `${btn.dataset.baseUrl}?variant=${select.value}` : btn.dataset.baseUrl;
    window.location.href = url;
  }, true);
})();
